<template>
  <div class="cust-edit">
    <el-card class="box-card">

      <div slot="header" class="clearfix title">
        <i class="iconfont eltte-doc"></i>
        <span>个人信息</span>
      </div>
      <div class="card-body">
        <el-form ref="form" :model="custForm" label-width="100px" size="small" :rules="addFormRules" label-position="left">

          <div class="base-info">
            <div class="title"> <span>基本信息</span> </div>
            <div class="base-box">
              <el-upload class="avatar-uploader" action="/api/file/upload" name="files" :data='{"type":"userpic"}' :show-file-list="false" :on-success="handleAvatarSuccess" :before-upload="beforeAvatarUpload">
                <img v-if="imgShow" :src="picSrc" class="avatar">
                <i v-else class="el-icon-circle-plus avatar-uploader-icon"></i>
              </el-upload>
              <div class="info-box">
                <el-row type="flex">
                  <el-form-item :label="'姓\u00a0\u00a0\u00a0\u00a0\u00a0\u00a0\u00a0名'" prop="name">
                    <el-input v-model="custForm.name"></el-input>
                  </el-form-item>
                  <el-form-item label="联系方式" prop="linkPhone">
                    <el-input v-model="custForm.linkPhone"></el-input>
                  </el-form-item>
                </el-row>
                <el-row type="flex" class="input-area">
                  <el-form-item :label="'性\u00a0\u00a0\u00a0\u00a0\u00a0\u00a0\u00a0别'" prop="sex">
                    <el-radio-group v-model="custForm.sex">
                      <el-radio :label="1">男</el-radio>
                      <el-radio :label="0">女</el-radio>
                    </el-radio-group>
                  </el-form-item>
                </el-row>
                <el-row type="flex">
                  <el-form-item label="性格特点" prop="nature">
                    <el-input v-model="custForm.nature"></el-input>
                  </el-form-item>
                  <el-form-item label="兴趣爱好" prop="hobby">
                    <el-input v-model="custForm.hobby"></el-input>
                  </el-form-item>
                </el-row>
              </div>
            </div>
          </div>
          <div class="base-info">
            <div class="title"> <span>职业信息</span> </div>
            <div class="info-box">
              <el-row type="flex">
                <el-form-item :label="'学\u00a0\u00a0\u00a0\u00a0\u00a0\u00a0\u00a0段'" prop="stage">
                   <!-- <el-select v-model="custForm.stage">
                    <el-option v-for="(value,key) in stageMap" :key="key" :label="value" :value="key">
                    </el-option>
                  </el-select>  -->
                  <el-input v-model="custForm.stage"></el-input>

                </el-form-item>
                <el-form-item :label="'学\u00a0\u00a0\u00a0\u00a0\u00a0\u00a0\u00a0科'" prop="subject">
                   <!-- <el-select v-model="custForm.subject">
                    <el-option v-for="(value,key) in subjectMap" :key="key" :label="value" :value="key+''">
                    </el-option>
                  </el-select>  -->
                  <el-input v-model="custForm.subject"></el-input>
                </el-form-item>
              </el-row>
              <el-row type="flex" class="input-area">
                <el-form-item :label="'地\u00a0\u00a0\u00a0\u00a0\u00a0\u00a0\u00a0区'" prop="addr">
                  <el-input v-model="custForm.addr"></el-input>
                </el-form-item>

                <el-form-item :label="'单\u00a0\u00a0\u00a0\u00a0\u00a0\u00a0\u00a0位'" class="train-day" prop="company">
                  <el-input v-model="custForm.company"></el-input>
                </el-form-item>
              </el-row>
              <el-row type="flex" class="input-area">
                <el-form-item :label="'职\u00a0\u00a0\u00a0\u00a0\u00a0\u00a0\u00a0位'" prop="job">
                  <el-input v-model="custForm.job"></el-input>
                </el-form-item>

                <el-form-item :label="'职\u00a0\u00a0\u00a0\u00a0\u00a0\u00a0\u00a0称'" class="train-day" prop="competent">
                  <el-input v-model="custForm.competent"></el-input>
                </el-form-item>
              </el-row>
            </div>
          </div>
          <div class="base-info">
            <div class="title"> <span>补充说明</span> </div>
            <div class="info-box">
              <el-row type="flex">
                <el-form-item prop="remark" class="remark">
                  <el-input type="textarea" :rows="4" placeholder="请在下方输入内容" v-model="custForm.remark"></el-input>

                </el-form-item>

              </el-row>
            </div>
          </div>
          <div class="base-info">
            <div class="title"> <span>相关文件</span> </div>
            <div class="info-box">
              <div class="upload-area">
                <el-upload class="upload-demo" ref='upload' :show-file-list="false" action="/api/file/upload" :on-success="handleSuccess" name="files" :data='{"type":"master"}'>
                  <el-button type="success">+ 上传文件</el-button>
                  <div slot="tip" class="el-upload__tip ext-info">支持扩展名: .rar .zip .doc .docx .xls .xlsx .jpg…</div>
                </el-upload>
                <div class="file" v-for="(file,index) in fileList " :key="index">
                  <div class="file-left" @click="handlePreview(file)">
                    <img v-if="file.suffName.indexOf('xls')>-1" src="../../assets/img/xls.png" alt="" srcset="">
                    <img v-else-if="file.suffName.indexOf('pdf')>-1" src="../../assets/img/pdf.png" alt="" srcset="">
                    <img v-else-if="['rar','zip'].includes(file.suffName)" src="../../assets/img/zip.png" alt="" srcset="">
                    <img v-else src="../../assets/img/doc.png" alt="" srcset="">
                    <span class="file-name">{{file.fileName}}</span>
                  </div>
                  <div class="tags">
                    <el-tag v-if="file.tag" size="small" type='danger' effect="dark" :closable='true' :disable-transitions="false" @close="handleClose(file)">
                      {{file.tag}}
                    </el-tag>
                    <el-input class="input-new-tag" v-if="fileId == file.uuid&&!file.tag " v-model="tagName" :ref="'saveTagInput'+file.uuid" size="mini" @keyup.enter.native="handleInputConfirm" @blur="handleInputConfirm">
                    </el-input>
                    <el-button v-if="fileId != file.uuid &&!file.tag " class="button-new-tag" type="primary" plain size="mini" @click="showInput(file.uuid)">+添加标签</el-button>
                  </div>
                  <i class="el-icon-close" @click="removeFile(file)"></i>
                </div>
              </div>
            </div>
          </div>
        </el-form>
      </div>
      <div class="commit-box">
        <el-button class="save-btn" @click="save">保存</el-button>
      </div>
    </el-card>
  </div>
</template>

<script>
import commonData from '../../common/commonData'
import * as resourceApi from '../../api/resourceAPI'
import moment from 'moment'

const validatorPhone = (rule, value, callback) => {
  if (value === '') {
    callback(new Error('手机号不能为空'))
  } else if (!/^1\d{10}$/.test(value)) {
    callback(new Error('手机号格式错误'))
  } else {
    callback()
  }
}
export default {
  components: {

  },
  props: {

  },
  data() {
    return {
      custForm: {},
      addFormRules: {
        name: [{ required: true, message: '请输入客户名字', trigger: 'blur' },],
        addr: [{ required: true, message: '请输入地区', trigger: 'blur' },],
        company: [{ required: true, message: '请输入单位', trigger: 'blur' },],
        job: [{ required: true, message: '请输入职位', trigger: 'blur' },],
        competent: [{ required: true, message: '请输入职称', trigger: 'blur' },],
        sex: [{ required: true, message: '选择性别', trigger: 'change' },],
        // stage: [{ required: true, message: '请选择学段', trigger: 'blur' },],
        // subject: [{ required: true, message: '请选择学科', trigger: 'change' },],
        linkPhone: [{ required: true, validator: validatorPhone, trigger: "blur" }],
      },
      stageMap: {},
      subjectMap: {},
      oldForm: {},
      imgShow: false,
      fileList: [],
      tagName: '',
      fileId: '',
      picSrc: '',
      oldFileList: []
    };
  },
  computed: {

  },
  watch: {

  },
  created() {
    this.stageMap = commonData.stage
    this.subjectMap = commonData.subject

  },
  async mounted() {
    this.userInfo = await this.$store.getters.getUserInfo

    await this.qryCust()
    await this.qryFileList()

  },
  methods: {

    async qryCust() {
      let id = this.$route.params.id
      let param = { name: 'tb_cust' }
      param.where = [{ filed: 'id', type: 'eq', value: id }]
      let res = await resourceApi.list(param)
      if (res.flag) {
        this.custForm = res.data.list[0]
        this.oldForm = { ...this.custForm }
        if (this.custForm.userPic) {
          this.imgShow = true
          this.picSrc = "http://" + window.location.hostname + "/userpic/" + this.custForm.userPic
        }
      }
    },
    async qryFileList() {
      let id = this.$route.params.id
      let param = { name: 'bs_file' }
      param.where = [{ filed: 'busiId', type: 'eq', value: id }, { filed: 'type', type: 'eq', value: '4' }]
      let res = await resourceApi.list(param)
      if (res.flag) {
        this.fileList = res.data.list
        this.oldFileList = [...this.fileList.map(aInfo => {
          return { ...aInfo }
        })]
      }

    },
    isSame() {
      if (this.oldFileList.length != this.fileList.length) {
        return false
      }
      return this.oldFileList.every(file => {
        let find = this.fileList.find(f => f.id == file.id)
        if (!find) {
          return false
        }
        if (Object.keys(find).length != Object.keys(file).length) return false
        for (const key in file) {
          if (file[key] != find[key]) {
            console.log('every', file[key], find[key]);
            return false
          }
        }
        return true
      })
    },
    async save() {
      await this.validate();
      let { id, ...custForm } = { ...this.custForm }
      let param = {}
      //ustForm.createTime = moment(new Date()).format('YYYY-MM-DD HH:mm:ss')
      let sets = []
      param.name = 'tb_cust'
      console.log(custForm, id);
      for (const key in custForm) {
        const val = custForm[key];
        if (val != undefined && val != this.oldForm[key]) {
          sets.push({ filed: key, value: val })
        }
      }
      console.log(sets);
      if (!sets.length && this.isSame()) return
      param.sets = sets
      param.where = [{ filed: "id", type: "eq", value: id }]
      this.$confirm('确认修改该客户吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        if (sets.length) {
          let res = await resourceApi.update(param)
          if (res.flag) {
            this.$message.success('修改客户信息成功！')
          }
        }
        if (!this.isSame()) {
          this.modifyFile()
          this.$message.success('修改客户信息成功！')
        }
      })
    },
    async modifyFile() {
      if (this.isSame()) {
        return
      }
      let param = {}
      let busiId = this.$route.params.id
      param.name = 'bs_file'
      let addIds = this.oldFileList.map(o => o.id)
      let delIds = this.fileList.map(o => o.id)
      let addList = this.fileList.filter(f => !addIds.includes(f.id))
      let delList = this.oldFileList.filter(f => !delIds.includes(f.id))
      let modList = this.fileList.filter(f => {
        let find = this.oldFileList.find(file => file.id == f.id)
        if (find) {
          for (const key in f) {
            if (f[key] != find[key]) {
              console.log('filter', f[key], find[key]);
              return true
            }
          }
        }
        return false
      })
      console.log('modList', modList);
      addList.forEach(async (file) => {
        file.busiId = busiId
        await this.saveFile(file)
      });
      modList.forEach(async (file) => {
        await this.updateFile(file)
      });
      delList.forEach(async (file) => {
        let param = {}
        param.name = 'bs_file'
        param.where = [{ filed: 'id', type: 'eq', value: file.id }]
        await resourceApi.del(param)
      });


    },
    async saveFile(file) {
      let param = {}
      param.name = 'bs_file'
      param.model = 'add'
      let sets = [{ filed: 'createId', value: this.userInfo.id }, { filed: 'createName', value: this.userInfo.username }]
      for (const key in file) {
        const val = file[key];
        if (val != undefined) {
          sets.push({ filed: key, value: val })
        }
      }
      param.sets = sets
      await resourceApi.update(param)
    },
    async updateFile(file) {
      let param = {}
      param.name = 'bs_file'
      let sets = []
      for (const key in file) {
        const val = file[key];
        if (val != undefined) {
          sets.push({ filed: key, value: val })
        }
      }
      console.log('updateFile', file);
      param.sets = sets
      param.where = [{ filed: 'id', type: 'eq', value: file.id }]
      await resourceApi.update(param)

    },
    async validate() {
      let flag = true
      await this.$refs.form.validate(async (valid, rules) => {
        if (!valid) {
          for (const key in rules) {
            flag = false;
            console.log(key, rules[key][0].message)
            this.$message.error(rules[key][0].message)
            throw Error(rules[key][0].message)
          }
          return
        }
      })
      if (!flag) {
        throw Error('校验失败')
      }
    },
    handleAvatarSuccess(res, file) {
      this.$set(this, 'picSrc', URL.createObjectURL(file.raw))
      this.$set(this.custForm, 'userPic', res.data[0])
      // this.custForm.userPic = URL.createObjectURL(file.raw);
      console.log("handleAvatarSuccess", this.custForm.userPic);
      this.imgShow = true

    },
    beforeAvatarUpload(file) {
      // const isJPG = file.type === 'image/jpeg';
      const isLt2M = file.size / 1024 / 1024 < 5;

      // if (!isJPG) {
      //   this.$message.error('上传头像图片只能是 JPG 格式!');
      // }
      if (!isLt2M) {
        this.$message.error('上传头像图片大小不能超过 5MB!');
      }
      return isLt2M;
    },

    handleSuccess(res, file, fileList) {
      if (res.flag) {
        this.$message.success('上传成功')
        this.fileList.push({ uuid: res.data[0], fileName: file.name, tag: '', suffName: file.name.substring(file.name.lastIndexOf('.') + 1), type: 4 })
      } else {
        this.$message.error(res.message)
      }
      console.log("handleSuccess", this.fileList);
    },
    removeFile(file) {
      return this.$confirm(`确定移除 ${file.fileName}？`).then(() => {
        this.fileList = this.fileList.filter(f => f.uuid != file.uuid)
      })

    },
    handleClose(file, tag) {//删除标签
      console.log('handleClose', file, tag);
      file.tag = ''
    },

    showInput(id) {//点击添加标签按钮
      this.fileId = id
      this.$nextTick(_ => {
        console.log("showInput", this.$refs, this.$refs.saveTagInput1);
        this.$refs['saveTagInput' + id][0].$refs.input.focus();
      });
    },

    handleInputConfirm() {//输入标签提交
      console.log('handleInputConfirm');
      let tagName = this.tagName;
      if (tagName) {
        // this.fileList.find(f => f.id == this.fileId).tags.push(tagName)
        this.fileList.find(f => f.uuid == this.fileId).tag = tagName
      }
      this.fileId = ''
      this.tagName = '';
    },

    async handlePreview(file) {
      let fileName = file.fileName
      let uuid = file.uuid
      let suffName = fileName.substring(fileName.lastIndexOf('.') + 1)
      console.log('预览pdf', fileName, suffName)
      let offices = ['doc', 'docx', 'xls', 'xlsx', 'ppt', 'pptx', 'pdf']
      let imgs = ['jpg', 'jpeg', 'png', 'gif', 'bmp']
      if (!offices.includes(suffName) && !imgs.includes(suffName) && 'txt' != suffName) {

        return
      }
      let res = await fileApi.preview({ uuid, suffName, fileName, type: 'cust' })
      console.log("handlePreview", suffName);
      if (offices.includes(suffName)) {
        let blob = new Blob([res], { type: 'application/pdf' })
        let href = URL.createObjectURL(blob)
        console.warn(href)
        this.$refs.preview.fileSrc = href
        // this.src = `./pdf/web/viewer.html?file=${encodeURIComponent(href)}`
        //window.open(`./pdf/web/viewer.html?file=${encodeURIComponent(href)}`);
        //this.src = this.getObjectURL(res)
        this.$refs.preview.fileVisible = true
      } else if (imgs.includes(suffName)) {
        let blob = new Blob([res])
        let href = URL.createObjectURL(blob)
        console.warn(href)
        this.$refs.preview.imgSrc = href
        this.$refs.preview.imgVisible = true
      } else if ('txt' == suffName) {
        console.log('txt', res);
        let blob = new Blob([res], { type: 'text/plain' })
        let href = URL.createObjectURL(blob)
        console.warn(href)
        this.$refs.preview.fileSrc = href
        this.$refs.preview.fileVisible = true

      }
    },
  },
};
</script>

<style  lang="less">
.cust-edit {
  .el-card {
    box-shadow: none !important;
    border: none !important;
    border-radius: 10px;
    padding: 0 20px;
    .el-card__header {
      padding: 10px 0px 20px 0px;
      .title {
        > i {
          font-size: 20px;
          color: #346aff;
          font-weight: 400;
        }
      }
    }
    .el-card__body {
      padding: 10px 20px;

      .base-info {
        .title {
          padding-bottom: 10px;
          border-bottom: 1px solid #dddddd;
          margin-bottom: 10px;
          > span {
            display: block;
            padding-left: 20px;
            position: relative;
            &::before {
              position: absolute;
              content: "";
              width: 4px;
              height: 20px;
              background: #346aff;
              opacity: 1;
              display: block;
              left: 0px;
              top: 1px;
            }
          }
        }
        .el-select {
          width: 200px;
        }
      }
      .base-info + .base-info {
        margin-top: 20px;
        position: relative;
        &::before {
          content: "";
          width: 120%;
          height: 5px;
          display: block;
          background: #f5f5fc;
          position: absolute;
          top: -20px;
          left: -40px;
        }
      }
      .el-row--flex {
        .el-form-item + .el-form-item {
          margin-left: 40px;
        }
        .el-input__inner {
          // width: 200px;
          position: relative;
        }
        .remark {
          width: 100%;
          .el-form-item__content {
            margin-left: 0 !important;
          }
        }
      }
      .commit-box {
        margin-top: 20px;
        text-align: center;
        padding-bottom: 20px;
        .save-btn {
          font-size: 16px;
          width: 300px;
          color: #fff;
          background: #3b63ff;
          border-radius: 10px;
          border: none;
        }
      }
    }
  }
  .base-box {
    display: flex;
    align-items: center;
    .avatar-uploader {
      margin-right: 20px;
      .el-upload {
        border: 1px dashed #d9d9d9;
        border-radius: 3px;
        cursor: pointer;
        position: relative;
        overflow: hidden;
        background: url("../../assets/img/pic.png");
        background-size: 100%;
      }
      .el-upload:hover {
        border-color: #409eff;
      }
      .avatar-uploader-icon {
        font-size: 30px;
        color: #8c939d;
        width: 160px;
        height: 160px;
        display: block;
        position: relative;
        color: #d3d3d3;
        &::before {
          position: absolute;
          bottom: 0px;
          right: 0px;
          bottom: 0px;
          right: 9px;
        }
      }
      .avatar {
        width: 160px;
        height: 160px;
        display: block;
      }
    }
  }
  .upload-area {
    padding: 20px;
    border: 1px solid #dfdfe1;
    border-radius: 5px;
    display: flex;
    flex-direction: column;

    .ext-info {
      font-size: 12px;
      color: #a6aab8;
      padding: 20px 0;
      margin: 0;
    }
    .file {
      display: flex;
      align-items: center;
      justify-content: space-between;
      .file-left {
        cursor: pointer;
        display: flex;
        align-items: center;
        width: 240px;

        img {
          width: 16px;
        }
        .file-name {
          margin-left: 10px;
          font-size: 13px;
          color: #606266;
        }
      }

      > .el-icon-close {
        font-size: 18px;
        cursor: pointer;
        color: #606266;
      }
    }
    .file + .file {
      margin-top: 10px;
    }
  }
}
</style>
